import React from 'react'

// atomic components
import Section from 'components/atoms/Section'
import SectionItem from 'components/atoms/SectionItem'

// shared components
import Camper from './Camper'
import OnlineHelpModal from 'components/shared/OnlineHelpModal'

const Campers = props => {
  const {
    title,
    account,
    subheaderText,
    buttonText,
    buttonRoute,
    reupRequired,
    setModal,
    editable
  } = props

  return (
    <Section
      title={title}
      subheaderText={subheaderText}
      buttonText={buttonText}
      buttonRoute={buttonRoute}
    >
      <OnlineHelpModal />
      {account.campers.map(camper => (
        <SectionItem key={camper.id}>
          <Camper
            camper={camper}
            account={account}
            setModal={setModal}
            reupRequired={reupRequired}
            editable={editable}
          />
        </SectionItem>
      ))}
    </Section>
  )
}

export default Campers
